import { render, staticRenderFns } from "./sourceDetail.vue?vue&type=template&id=45ae96d1&"
import script from "./sourceDetail.vue?vue&type=script&lang=js&"
export * from "./sourceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports